import React from 'react';
import { useSelector } from 'react-redux';
import NewFormPreview from '../../../partials/form-preview/form-preview';
import { selectForm, selectFormDesign, selectRowControls } from '../../selectors';

const MainForm = () => {
  const form = useSelector((state) => selectForm(state));
  const formDesign = useSelector((state) => selectFormDesign(state));
  const rowCtrls = useSelector((state) => selectRowControls(state));
  return <NewFormPreview form={form} formDesign={formDesign} rowCtrls={rowCtrls} />;
};

export default MainForm;
